import { TFunction } from "i18next";
import { ExamPeriodMonitorState, Report } from "@types";
import { ApexOptions } from "apexcharts";

export const reportsPageGraph = (t: TFunction<"translation", undefined>, monitorData?: Report[], ): ApexOptions => {

    let passedParticipants = monitorData?.filter((item) => {
      if (item.examInstanceState === ExamPeriodMonitorState.Completed && item.hasPassed) {
        return true;
      }
      return false
    }).length || 0;
    let notPassedParticipants = monitorData?.filter((item) => {
      if (item.examInstanceState === ExamPeriodMonitorState.Completed && !item.hasPassed) {
        return true;
      }
      return false
    }).length || 0;
    let excludedParticipants = monitorData?.filter((item) => item.examInstanceState === ExamPeriodMonitorState.Excluded).length || 0;
          
    return {
      series: [passedParticipants, notPassedParticipants, excludedParticipants],
    chart: {
        width: 380,
        type: 'donut',
        background: 'transparent'
      },

      colors: ['#00E396', '#FF4560', '#775DD0'],
    labels: [t("table.passed"), t("table.failed"), t("table.disqulified")],
    tooltip: {
    enabled: true
    },
    legend: {
        position: 'bottom'
    },   
  }
}